import { TOOLTIP_STYLE_BAR } from 'ChartApp/ts/features/charts-shared/constants';
export const PERFORMANCE_CHART_CONFIGURABLE_OPTIONS = {
    showLatestValueLabels: true,
    tooltipStyle: TOOLTIP_STYLE_BAR,
    yAxisWidth: 60,
};
